import React, { useEffect, useState } from 'react';
import { StoryblokComponent } from 'storyblok-js-client';
import { blokToComponent, filterProps } from '../helpers';
import { parseAssetSource } from '../props/asset';
import { Props } from '../types';
import { analyzeLink } from '../../services/link-analyzer';

export const RocheTeaserExternal = ({
  blok, slot, getComponent,
}: Props): JSX.Element => {
  const teaserImage = blok?.teaser_image?.[0];
  const { slotted } = filterProps(blok);
  const [state, setState] = useState({
    internalLinkUrl: '',
    isExternalLink: false,
  });

  useEffect(() => {
    const { internalLinkUrl, isExternalLink } = analyzeLink(blok?.page);
    setState({ internalLinkUrl, isExternalLink });
  }, []);

  const slottedComponents = Object.keys(slotted)
    .flatMap((key) => (slotted[key] as StoryblokComponent<string>[]).map(
      (component) => (component.component === 'roche-button'
        ? {
          ...component,
          slot: key,
          'no-margin': blok.layout.indexOf('teaser--card') === 0,
          appearance: 'tertiary',
        }
        : {
          ...component,
          slot: key,
        }),
    ));

  return (
    <roche-teaser
      layout={blok?.layout}
      teaser-title={blok?.teaser_title}
      teaser-overline={blok?.teaser_overline}
      teaser-description={blok?.teaser_description}
      teaser-image={teaserImage?.brightcove_id || parseAssetSource(teaserImage?.src.filename)}
      teaser-url={state.internalLinkUrl || `${blok?.page}`}
      loaded={blok !== undefined}
      is-external-link={state.isExternalLink}
      slot={slot}
    >
      {slottedComponents.map((component, index) => blokToComponent({ blok: component, getComponent }, `${index}`))}
      <a href={state.internalLinkUrl || `${blok?.page}`}>{blok?.teaser_title}</a>

    </roche-teaser>
  );
};
